import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.json.stringify.js";
import Protocol from './protocol';
import { AtomError } from './lib/error';
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
var TME_LOGINTYPE = {
  1: 'wx',
  2: 'qq'
};
var uniqueId = 1;
var queue = []; // function

/**
 * QQ音乐JSBridge
 * @class QQMusicBridge
 * @extends {Phone}
 */

var QQMusicBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(QQMusicBridge, _Protocol);

  var _super = _createSuper(QQMusicBridge);

  function QQMusicBridge() {
    var _this;

    _classCallCheck(this, QQMusicBridge);

    _this = _super.call(this);
    _this.name = 'QQMusicBridge';
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
      if (!window.M && env.isIos) {
        window.M = {
          client: _assertThisInitialized(_this)
        };
      }

      if (queue.length > 0) {
        queue.forEach(function (args) {
          var _this2;

          (_this2 = _this).callNative.apply(_this2, _toConsumableArray(args));
        });
        queue.length = 0;
      }
    });
    return _this;
  }

  _createClass(QQMusicBridge, [{
    key: "invoke",
    value: function invoke() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 5000
      };

      // 兼容直接invoke的场景，可直接调用内部抹平方法
      if (typeof this[api] === 'function') {
        return this[api](params, options);
      }

      return this.call(api, params, options);
    }
    /**
     * 真正调用Bridge
     * @param {String} api
     * @param {Object} params
     * @param {Object} options
     * @returns
     */

  }, {
    key: "call",
    value: function call() {
      var _this3 = this;

      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 5000
      };
      console.log("[QQMusicBridge] invoke ".concat(api, " params="), params);

      var _ref = api.match(/^([a-z]+)\.([a-z]+)?/i) || ['', 'core', api],
          _ref2 = _slicedToArray(_ref, 3),
          module = _ref2[1],
          apiName = _ref2[2];

      return new Promise(function (resolve, reject) {
        var timer;

        if (!window.M) {
          options.timeout = 0;
        }

        if (options.timeout > 0) {
          timer = setTimeout(function () {
            reject(new AtomError("[QQMusicBridge] invoke '".concat(apiName, "' timeout ").concat(options.timeout, "ms")));
          }, options.timeout);
        }

        _this3.callNative(module, apiName, params, function () {
          var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          console.log("[QQMusicBridge] invoke ".concat(apiName, " callback="), result);
          clearTimeout(timer);

          if (result && result.code === 0) {
            resolve(result.data);
          } else {
            reject(new AtomError(result.msg, result.code));
          }
        });
      });
    }
  }, {
    key: "callNative",
    value: function callNative(module) {
      var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!window.M) {
        queue.push([module, api, params, callback]);
        return;
      }

      if (window.M) {
        return window.M.client.invoke(module, api, params, callback);
      }

      var callbackId = "qqmusic_".concat(uniqueId, "_").concat(new Date().getTime());
      uniqueId += 1;

      if (typeof callback === 'function') {
        window[callbackId] = callback;
      }

      var nativeParams = _objectSpread({}, params);

      var schemeUrl = "qqmusic://qq.com/".concat(module, "/").concat(api, "?p=").concat(encodeURIComponent(JSON.stringify(nativeParams)), "#").concat(callbackId);
      var proxyFrame = document.createElement('iframe');
      proxyFrame.style.cssText = 'width:0;height:0;border:none;position:fixed;top:0;left:0;'; // 使可能存在的 html2canvas 忽略这个 iframe

      proxyFrame.setAttribute('data-html2canvas-ignore', 'true');
      proxyFrame.src = schemeUrl;

      proxyFrame.onload = function () {
        this.remove();
      };

      document.body.appendChild(proxyFrame);
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      if (event === 'onActionLoginFinish') {
        event = 'loginState';
      }

      this.call('event.on', {
        event: event
      }, callback);
    }
  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      return this.call('device.getDeviceInfo');
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      return this.call('data.getUserInfo', {}).then(function (res) {
        var type = TME_LOGINTYPE[cookie.get('tmeLoginType')];

        if (!type) {
          return null;
        }

        return _objectSpread({
          headurl: res.face,
          nick: res.nickname,
          type: type
        }, res);
      });
    }
    /**
     * openLogin
     * 腾讯体育该接口不支持，已登录状态下再调用
     * 如果已登录调用会返回结果，不显示登录弹窗
     */

  }, {
    key: "openLogin",
    value: function openLogin() {
      var isLogin = !!TME_LOGINTYPE[cookie.get('tmeLoginType')];

      if (isLogin) {
        this.call('ui.logout');
      }

      return this.call('ui.login', {}, {
        timeout: 300000
      }).then(function () {
        if (env.isIos) {
          // 由于iOS无法及时更新cookie，需要更新
          location.reload();
        }

        return true;
      })["catch"](function (e) {
        if (isLogin) {
          // 如果已登录过，因为会强制退出登录，需要刷新页面
          location.reload();
        }

        throw e;
      });
    }
    /**
     * switchLogin
     * @parma {String} type - 账号类型
     */

  }, {
    key: "switchLogin",
    value: function switchLogin() {
      return this.openLogin();
    }
    /**
     * switchLogin
     */

  }, {
    key: "switchLoginState",
    value: function switchLoginState() {
      return this.switchLogin();
    }
  }, {
    key: "close",
    value: function close() {
      return this.call('ui.closeWebview');
    }
  }, {
    key: "closeH5",
    value: function closeH5() {
      return this.close();
    }
    /*
     * 打开新页面
     * @param {String} url - 页面链接
     */

  }, {
    key: "openUrl",
    value: function openUrl() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!url.match(/^https?:\/\//)) {
        return this.openView(url);
      } // special: qqmv, 是音乐侧针对视频适配的指定拉起支持sdk能力的webview
      // 10.18.5 支持


      return this.call('ui.openUrl', {
        url: url,
        special: 'qqmv'
      })["catch"](function () {
        location.href = url;
      });
    }
    /*
     * 跳转伪协议
     * @param {String} url - schema链接
     */

  }, {
    key: "openView",
    value: function openView() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      location.href = url;
      return Promise.resolve();
    }
    /*
     * 保存图片
     * @param {String} url - 支持base/http url
     */

  }, {
    key: "saveImage",
    value: function saveImage(_ref3) {
      var _ref3$url = _ref3.url,
          url = _ref3$url === void 0 ? '' : _ref3$url;
      return this.call('media.saveImage', {
        content: url
      });
    }
    /*
     * 设置页面标题
     * @param {String} title - 标题
     */

  }, {
    key: "setTitle",
    value: function setTitle() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.call('ui.refreshTitle', {
        title: title
      });
    }
  }]);

  return QQMusicBridge;
}(Protocol);

export default new QQMusicBridge();